import { BaseFieldComponentProps } from 'react-bootstrap-formutil';

// 拼音填写的时候数据需要经过处理
export const handlePinYinParser: BaseFieldComponentProps['$parser'] = (value, $setViewValue) => {
    return $setViewValue(value.replace(/[^a-z\s]+/gi, '').toUpperCase());
};
export const handlePinYinFormatter: BaseFieldComponentProps['$formatter'] = (value, $setViewValue) => {
    return handlePinYinParser(value, $setViewValue);
};
